import { defineComponent as u, createElementBlock as m, openBlock as d, withModifiers as f, renderSlot as c, createElementVNode as b, createVNode as n, unref as a, withCtx as r, createTextVNode as s, toDisplayString as v } from "vue";
import { ScalarButton as l } from "@scalar/components";
const g = { class: "flex justify-between gap-10" }, y = /* @__PURE__ */ u({
  __name: "SidebarListElementForm",
  props: {
    danger: { type: Boolean },
    label: {}
  },
  emits: ["cancel", "submit"],
  setup(x, { emit: i }) {
    const o = i;
    return (t, e) => (d(), m("form", {
      class: "flex flex-col gap-4 text-base",
      onSubmit: e[1] || (e[1] = f((p) => o("submit"), ["prevent"]))
    }, [
      c(t.$slots, "default", {}, void 0, !0),
      b("div", g, [
        n(a(l), {
          class: "flex h-8 cursor-pointer items-center gap-1.5 px-2.5 shadow-none focus:outline-none",
          type: "button",
          variant: "outlined",
          onClick: e[0] || (e[0] = (p) => o("cancel"))
        }, {
          default: r(() => e[2] || (e[2] = [
            s(" Cancel ")
          ])),
          _: 1,
          __: [2]
        }),
        n(a(l), {
          class: "custom-scroll h-8 gap-1.5 px-2.5 font-medium whitespace-nowrap shadow-none focus:outline-none",
          type: "submit",
          variant: t.danger ? "danger" : "solid"
        }, {
          default: r(() => [
            s(v(t.label ?? "Save"), 1)
          ]),
          _: 1
        }, 8, ["variant"])
      ])
    ], 32));
  }
});
export {
  y as default
};
